export default "__VITE_ASSET__Dct83udk__"